import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import '../typography/typography';
import css from './form-password-strength-meter.css';

const FormPasswordStrengthMeter = ({
  label,
  low,
  high,
  max,
  optimum,
  value,
}) => (
  <div className={classnames(css['ds-form-password-meter'])}>
    <span>{label}</span>
    <meter low={low} high={high} max={max} optimum={optimum} value={value} />
  </div>
);

FormPasswordStrengthMeter.defaultProps = {
  label: 'Strength',
  low: 8,
  high: 12,
  max: 13,
  optimum: 13,
  value: 0,
};

FormPasswordStrengthMeter.propTypes = {
  label: PropTypes.string,
  low: PropTypes.number,
  high: PropTypes.number,
  max: PropTypes.number,
  optimum: PropTypes.number,
  value: PropTypes.number,
};

export default FormPasswordStrengthMeter;
